module.exports = __webpack_public_path__ + "img/bg_a.f8ad7d35.png";